module.exports = __webpack_public_path__ + "static/media/usa-today-logo.2308730b.svg";